import i18next from 'i18next';
import ToolTip from 'src/components/Tooltip/Tooltip';
import { formatDate } from 'src/utils';
import _ from 'lodash';
import { StellantisQuoteInfoTooltip, StellantisUtils } from 'src/components/Stellantis';
import { RoleEnum } from 'src/api';

export const columnsData = [
  {
    id: 'requestDate',
    Header: i18next.t('requestDate'),
    accessor: 'requestDate',
    sortType: (a: any, b: any) => {
      return new Date(a.values.requestDate).getTime() - new Date(b.values.requestDate).getTime();
    },
    Cell: ({ row }) => {
      const rawDate = row?.original?.requestDate;
      if (!rawDate) return null;
      const formatted = formatDate(rawDate + "Z", 'it-IT', true);
      return formatted === 'Invalid Date' ? rawDate : formatted;
    },
  },
  {
    accessor: 'dealer',
    id: 'dealer',
    Header: i18next.t('dealer_or_segnalatore'),
    Cell: ({ row }) => {
      let value = row?.original?.dealer;

      if (row?.original?.requestedByRole === RoleEnum.SEGNALATORE) {
        value = (
          <>
            <div>{value}</div>
            <small>{'(Segnalatore)'}</small>
          </>
        )
      }

      return value;
    }
  },
  {
    id: 'requestedBy',
    Header: i18next.t('user'),
    minWidth: 290,
    accessor: (values) => {
      return values.requestedByFullname || values.requestedBy;
    },
    Cell: ({ row }) => {
      const elId = `info-requestedBy-${row.id}`;
      const maxChars = 20;
      const value = (row?.original?.requestedByFullname || row?.original?.requestedBy);
      const shouldTruncate = value?.length > maxChars;
      const computedValue = _.truncate(value, { 'length': maxChars });

      return (
        <div id={elId}>
          {computedValue}
          {shouldTruncate && <ToolTip
            anchorId={elId}
            content={value}
            className="w-75"
          />}
        </div>
      )
    },
  },
  {
    accessor: 'quote.marca',
    id: 'marca',
    Header: i18next.t('marca'),
  },
  {
    accessor: 'quote.modello',
    id: 'modello',
    Header: i18next.t('modello'),
  },
  {
    accessor: 'quote.allestimento',
    id: 'allestimento',
    Header: i18next.t('allestimento'),
    width: 140,
    Cell: ({ row }) => {
      const elId = `info-allestimento-${row.id}`;
      const maxChars = 50;
      const value = row?.original?.quote?.allestimento || '';
      const shouldTruncate = value?.length > maxChars;
      const computedValue = _.truncate(value, { 'length': maxChars });

      return (
        <div id={elId} className='text-wrap' style={{ minWidth: 240 }}>
          {computedValue}
          {shouldTruncate && <ToolTip
            anchorId={elId}
            content={value}
            className="w-75"
          />}
        </div>
      )
    },
  },
  {
    Header: i18next.t('other'),
    id: 'expander',
    Cell: ({ row }) => {
      return <StellantisQuoteInfoTooltip quoteRequest={row.original} type='history' />
    },
  },
  {
    Header: i18next.t('gestione'),
    id: 'gestione',
    disableSortBy: true,
    accessor: (values) => {
      return values.assignedToFullname || values.assignedTo || 'gestione';
    },
    Cell: ({ row }) => {
      const quoteRequest = row.original || {};
      if (StellantisUtils.isUnquotable(quoteRequest)) {
        return <div className="fw-bold text-danger">
          {i18next.t('quote_status_' + quoteRequest.status?.toLowerCase())}
        </div>
      }

      const maxChars = 20;
      const anchorId = `info-assignee-${quoteRequest.id}`;
      const assignee = (quoteRequest.assignedToFullname || quoteRequest.assignedTo);
      const computedValue = _.truncate(assignee, { 'length': maxChars });
      return (
        <div id={anchorId} key={anchorId} className="fw-bold">
          {computedValue}
          <ToolTip
            anchorId={anchorId}
            content={assignee}
            className="w-75"
          />
        </div>
      )
    },
  },
  {
    Header: i18next.t('processing_time'),
    id: 'processing_time',
    accessor: 'processingTime',
    className: 'processing-time',
    disableSortBy: true,
    Cell: ({ row }) => {
      const quoteRequest = row.original || {};
      if (StellantisUtils.isUnquotable(quoteRequest)) {
        return <div className="fw-bold text-danger">
          {quoteRequest?.processingTime}
        </div>
      }

      return (
        <div className="fw-bold">
          {quoteRequest?.processingTime}
        </div>
      )
    },
  },
  {
    accessor: 'actions',
    id: 'actions',
    Header: '',
    disableSortBy: true,
  },
];
